import Vue from 'vue';

import './filters/filters';

import UserInfo from './user-info/UserInfo.vue';
import CustomDialog from './CustomDialog.vue';
import CircularLoading from './CircularLoading.vue';
import SearchText from './SearchText.vue';
import ConfirmDialog from './ConfirmDialog.vue';
import OverlayCircularLoading from './OverlayCircularLoading.vue';
import SelectEnum from './SelectEnum.vue';
import DatePicker from './DatePicker.vue';
import TimePicker from './TimePicker.vue';
import TimePickerInDialog from './TimePickerInDialog.vue';
import TimePickerStartEnd from './TimePickerStartEnd.vue';
import ColorPicker from './ColorPicker.vue';

Vue.component('twUserInfo', UserInfo);
Vue.component('twCustomDialog', CustomDialog);
Vue.component('twCircularLoading', CircularLoading);
Vue.component('twSearchText', SearchText);
Vue.component('twConfirmDialog', ConfirmDialog);
Vue.component('twOverlayCircularLoading', OverlayCircularLoading);
Vue.component('twSelectEnum', SelectEnum);
Vue.component('twDatePicker', DatePicker);
Vue.component('twTimePicker', TimePicker);
Vue.component('twTimePickerInDialog', TimePickerInDialog);
Vue.component('twTimePickerStartEnd', TimePickerStartEnd);
Vue.component('twColorPicker', ColorPicker);
